import IncidentSearchBar from './IncidentSearchBar';

export default IncidentSearchBar;
